"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneInput = void 0;

var _fieldAlert = require("../field-alert");

var _fieldError = require("../field-error");

var _fieldsStyledComponents = require("../fields-styled-components");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _reactForms = require("@seegno/react-forms");

var _reactPhoneInput = _interopRequireDefault(require("react-phone-input-2"));

var _react = _interopRequireWildcard(require("react"));

var _highRes = _interopRequireDefault(require("react-phone-input-2/lib/high-res.css"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["className", "defaultCountry", "disabled", "label", "helpText", "id", "name"],
    _excluded2 = ["error", "meta", "onChange", "value"];

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var caretIcon24 = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M19.25 9.4l-3.5 3.7c-.8.8-1.8 1.3-3 1.4h-1.6c-1.1-.1-2.1-.6-2.9-1.5l-3.5-3.8\"/></svg>";

/**
 * Default country code.
 */
var defaultCountryCode = 'us';
/**
 * Excluded countries.
 */

var excludedCountries = ['cu', 'ir', 'kp', 'sy', 'ss'];
/**
 * `StyledFormGroup` styled component.
 */

var StyledFormGroup = (0, _styledComponents["default"])(_fieldsStyledComponents.FormGroup).withConfig({
  displayName: "phone-input__StyledFormGroup",
  componentId: "sc-1ka08r3-0"
})(["", " .react-tel-input{background-color:", ";border:2px solid ", ";border-radius:", "px;height:50px;transition:", ";transition-property:background-color,border-color;&:hover{", "}", " ", " ", " ", " .form-control{", " background:transparent;border:none;color:", ";height:100%;outline:none;padding:20px 14px 6px 70px;transition:color ", ";width:100%;", " ", " &.open{z-index:", ";}}.selected-flag{padding-left:10px;", " .arrow{background:url('data:image/svg+xml;utf8,", "');border:none;height:16px;transform:translate(-3px,-4px);width:16px;&.up{border:none;transform:translate(-3px,-4px) rotate(180deg);}}&:hover,&:focus{background:transparent;}}.flag-dropdown{background-color:unset;border:none;height:100%;padding-bottom:6px;padding-top:20px;transition:opacity ", ";&.open{width:100%;z-index:", ";}&.open,&.open .selected-flag,&:hover,&:focus{background:transparent;}", "}.country-list{border-radius:", "px;box-shadow:", ";width:inherit;.flag{left:20px;margin-top:-3px;top:8px;}.divider{border-color:", ";}.country{outline:0;padding:8px 0 8px 50px;position:relative;.dial-code{color:", ";}&.highlight,&:hover{background-color:", ";}}}}"], _highRes["default"], (0, _styles.color)('gray300'), (0, _styles.color)('gray300'), (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)({
  hasError: false,
  hasFocus: false
}, (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('gray400'))), (0, _styledTools.ifProp)('hasFocus', (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('primary'))), (0, _styledTools.ifProp)('hasError', (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('danger'))), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["background-color:", ";border-color:", ";"], (0, _styles.color)('gray100'), (0, _styles.color)('gray100'))), _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      height: 54px;\n    "]))), _fieldsStyledComponents.textDesktopStyle, (0, _styles.color)('secondary'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))), _styles.media.min('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        padding-top: 20px;\n        padding-right: 10px;\n      "]))), function (props) {
  return (0, _styledTools.theme)('zIndex.dropdown.menu')(props) + 1;
}, _styles.media.min('md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        padding-left: 14px;\n      "]))), caretIcon24, (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.theme)('zIndex.dropdown.menu'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["opacity:0.3;"])), (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.theme)('boxShadow.dropdownMenu'), (0, _styles.color)('gray200'), (0, _styles.color)('secondary'), (0, _styles.color)('blue200'));
/**
 * `StyledLabel` styled component.
 */

var StyledLabel = (0, _styledComponents["default"])(_fieldsStyledComponents.Label).withConfig({
  displayName: "phone-input__StyledLabel",
  componentId: "sc-1ka08r3-1"
})(["z-index:1;", ""], (0, _styledTools.ifProp)('isFloating', (0, _styledComponents.css)(["transform:translateY(-6px);"])));
/**
 * `PhoneInput` component.
 */

function PhoneInput(props, ref) {
  var className = props.className,
      _props$defaultCountry = props.defaultCountry,
      defaultCountry = _props$defaultCountry === void 0 ? defaultCountryCode : _props$defaultCountry,
      disabled = props.disabled,
      label = props.label,
      helpText = props.helpText,
      id = props.id,
      name = props.name,
      rest = _objectWithoutProperties(props, _excluded);

  var _useField = (0, _reactForms.useField)(name),
      error = _useField.error,
      active = _useField.meta.active,
      onChange = _useField.onChange,
      value = _useField.value,
      fieldProps = _objectWithoutProperties(_useField, _excluded2);

  var _useFormState = (0, _reactForms.useFormState)(),
      alreadySubmitted = _useFormState.alreadySubmitted,
      isSubmitting = _useFormState.isSubmitting;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      dialCode = _useState2[0],
      setDialCode = _useState2[1];

  var hasError = !!error && alreadySubmitted;
  var isDisabled = disabled || isSubmitting;
  var handleOnChange = (0, _react.useCallback)(function (value, data) {
    var dialCode = data === null || data === void 0 ? void 0 : data.dialCode;
    var hasPhoneValue = !!value && dialCode !== value;
    var phoneValue = hasPhoneValue ? "+".concat(value) : undefined;
    setDialCode(dialCode);
    onChange(phoneValue);
  }, [onChange]);
  return /*#__PURE__*/_react["default"].createElement(StyledFormGroup, {
    className: className,
    disabled: isDisabled,
    hasError: hasError,
    hasFocus: active
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    disabled: isDisabled,
    htmlFor: id !== null && id !== void 0 ? id : name,
    isFloating: true
  }, label), /*#__PURE__*/_react["default"].createElement(_reactPhoneInput["default"], _extends({}, fieldProps, {
    country: defaultCountry,
    countryCodeEditable: !(value || active),
    disabled: disabled,
    excludeCountries: excludedCountries,
    inputProps: _objectSpread(_objectSpread({}, rest), {}, {
      id: id !== null && id !== void 0 ? id : name,
      name: name
    }),
    onChange: handleOnChange,
    placeholder: null,
    preferredCountries: [defaultCountry],
    ref: ref,
    specialLabel: null,
    value: value || dialCode
  })), helpText && /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: !hasError
  }, helpText), /*#__PURE__*/_react["default"].createElement(_fieldError.FieldError, {
    error: error,
    isOpen: hasError,
    name: name
  }));
}
/**
 * Forwarded `PhoneInput`.
 */


var ForwardedInput = /*#__PURE__*/(0, _react.forwardRef)(PhoneInput);
/**
 * Export `PhoneInput` component.
 */

exports.PhoneInput = ForwardedInput;